/**
 * @module unsplash/Unsplash
 */

import { 
	Plugin, 
	View,
	ButtonView,
	Dialog,

} from 'ckeditor5';

import unsplashIcon from '../theme/icons/unsplash.svg';
import PickerView from './ui/pickerView.js';

import '../theme/unsplash.css';

/**
 * The Unsplash plugin. It introduces the `'unsplash'` buttons.
 *
 * It uses the
 * {@link module:ui/dialog/dialogview~DialogView dialog view plugin}.
 *
 * @extends module:core/plugin~Plugin
 */
export default class Unsplash extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Unsplash';
	}

	/**
	 * @inheritDoc
	 */
	get requires() {
		return [ Dialog ]
	}

	unsplashPickerView;

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

		this.unsplashPickerView = this._createUnsplashPickerView()
		this.accreditationView = this._createUnsplashAccreditationView();

		// Register the "unsplash" button, so it can be displayed in the toolbar.
		editor.ui.componentFactory.add( 'unsplash', locale => {
			const view = new ButtonView( locale );

			view.set( {
				label: t( 'Insert Image from Unsplash' ),
				icon: unsplashIcon,
				tooltip: true
			} );

			/// Create dialog view after clicking the toolbar button.
			this.listenTo( view, 'execute', () => {
				// Get dialog plugin from CKEditor
				const dialog = this.editor.plugins.get('Dialog')

				// If the button is turned on, hide the dialog.
				if (view.isOn) {
					dialog.hide();
					view.isOn = false;

					return;
				}

				view.isOn = true;

				const containerView = new View( locale );
		
				containerView.setTemplate({
					tag: 'div',
					attributes: {
						class: "ck-unsplash-container",
						tabindex: -1
					},
					children: [
						this.unsplashPickerView,
						this.accreditationView,
					]
				});

				// Tell the plugin to display a dialog with the title, content, and one action button.
				dialog.show({
					id: 'unsplash-dialog',
					title: 'Insert Unsplash image',
					content: containerView,
					actionButtons: [
						{
							label: 'Close',
							class: 'ck-button-action',
							withText: true,
							onExecute: () => dialog.hide()
						}
					],
					onHide() { view.isOn = false; }
				});
			} );

			return view;
		} );
	}

	_createUnsplashPickerView() {
		const editor = this.editor;
		const config = editor.config.get('unsplash')

		const unsplashPickerView = new PickerView( editor.locale, editor.model, config)

		return unsplashPickerView;
	}

	_createUnsplashAccreditationView() {
		const view = new View( this.locale );

		view.setTemplate({
			tag: "p",
			attributes: {
				class: "unsplash-accreditation",
			},
			children: [{
				tag: "small",
				children: [
					"Photos by ",
					{
						tag: "a",
						attributes: {
							rel: "noreferrer",
							target: "_blank",
							cursor: "pointer !important",
							href: "https://unsplash.com/?utm_source=implement&utm_medium=referral"
						},
						children: [
							"Unsplash"
						]
					},
				]
			}]
		})

		return view;
	}
}
